module.exports = __webpack_public_path__ + "static/page-banner-flexprint-f8a26921b4f67a407709d940f8384525.png";